const data = ['dadbod', 'dadbrand', 'dadlife', 'dadlifestyle'];

export default data;
